import { PiMagnifyingGlassLight, PiQuestionLight } from 'react-icons/pi';
import { IconButton } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useTranslation } from 'react-i18next';

const TooltipSamplesSelector = () => {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton noHover className='hover:text-accent-blue'>
          <PiQuestionLight size={28} />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent className='w-58' sideOffset={8} side='right'>
        <div className='w-full m-2'>
          <p className='text-sm'>
            <span className='inline-flex align-middle mr-1'>
              <PiMagnifyingGlassLight size={20} className='fill-accent-blue' />
            </span>
            {t('tooltip.samplesSelector.search_help_1')}
            {/* {t('tooltip.samplesSelector.search_help_2')} */}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipSamplesSelector;
